export default "__VITE_PUBLIC_ASSET__36c80862__"